import { deleteLogo, saveInstituteDetails } from "actions/profileNew";
import { Button } from "components/Button";
import PageHeader from "components/pageHeader";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Prompt, useHistory } from "react-router";
import SaveConfirmation from "./saveConfirmation";
import { DetailSection, EditImage, ImageComponent } from "./subComponents";
import { designations } from "./userProfile";
import { validateEmail, isPhoneFormatInvalid } from "./userProfileData";
import { getAddressFromPin } from "./postalApi";
import { isValidPhoneNumber } from "react-phone-number-input";

const getContactPhoneError = (phone) => {
      if (!phone || phone.trim() === "" || phone === "+") {
        return null;
      }
      if (!phone.startsWith("+91")) {
        return null;
      }
      const hasTyped = phone.length > 3;
      if (!hasTyped) {
        return null;
      }
      if (isPhoneFormatInvalid(phone)) {
        return "Mobile number should start with 6-9";
      }
      return !isValidPhoneNumber(phone) ? "Please enter valid number" : null;
    };

export const instituteProfileDetails = (
  instituteProfile,
  handleInputChange,
  user
) => {

  return [
    {
      heading: "Institute details",
      // subHeading: "Edit/update institute details and more",
      subHeading: "",
      fields: [
        {
          label: "Name",
          type: "text",
          value: instituteProfile?.instituteName,
          required: true,
          disabled: true,
          placeholder: "Enter institute name...",
        },
        {
          label: "Institute type",
          type: "select",
          value: instituteProfile?.instituteType,
          required: true,
          disabled: false,
          placeholder: "Select institute type...",
          options: ["Private Limited", "Proprietorship", "Partnership", "LLP", "Trust", "Society", "Others"],
          onChange: (value) => handleInputChange(value, "instituteType"),
        },

        {
          label: "Website",
          type: "text",
          value: instituteProfile?.website,
          required: false,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "website"),
          placeholder: "Enter institute website...",
        },
        {
          label: "Number of students",
          type: "select",
          value: instituteProfile?.noOfStudents,
          required: true,
          disabled: true,
          // onChange: (value) => handleInputChange(value, "noOfStudents"),
          placeholder: "Select students...",
          options: ["1-100", "101-500"],
        },
        {
          label: "Building No./Locality/Area",
          type: "text",
          value: instituteProfile?.locality,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "locality"),
          placeholder: "Enter Building/Locality/Area...",
        },
        {
          label: "Pincode",
          type: "text",
          value: instituteProfile?.pincode,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "pincode"),
          placeholder: "Enter Pincode...",
          error: (() => {
            const pin = instituteProfile?.pincode;
            if (pin && pin.length >= 1 && pin.length < 6) {
              return "Enter valid pincode";
            }
            return instituteProfile?.pincodeValid ? "Enter valid pincode" : "";
          })()
        },
        {
          label: "State",
          type: "text",
          value: instituteProfile?.state,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "state"),
          placeholder: "Enter State...",
        },
        {
          label: "District",
          type: "text",
          value: instituteProfile?.city,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "city"),
          placeholder: "Enter District...",
        },
        {
          label: "Country",
          type: "text",
          value: instituteProfile?.country,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "country"),
          placeholder: "Enter Country...",
        },
        {
          label: "Unique ID",
          type: "text",
          value: instituteProfile?.instituteId,
          required: true,
          disabled: true,
          onChange: {},
        },
        {
          label: "Domain URL",
          type: "text",
          value: instituteProfile?.url,
          required: true,
          disabled: true,
          onChange: {},
          placeholder: "Enter Country...",
        },
      ],
    },
    {
      heading: "Secondary contact details",
      subHeading:
        "This person will be the point of contact between the institute and the Aulas team in case the primary contact person (Super Administrator) is unreachable.",
      fields: [
        {
          label: "Name",
          type: "text",
          value: instituteProfile?.contactName,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "contactName"),
          placeholder: "Enter name...",
        },
        {
          label: "Email ID",
          type: "text",
          value: instituteProfile?.contactEmail || "",
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "contactEmail"),
          placeholder: "Enter email id...",
          error: validateEmail(instituteProfile?.contactEmail)
            ? "Enter valid email id"
            : null
            ? "Enter valid email id"
            : null,
        },
        {
          label: "Mobile Number",
          type: "phone",
          value: instituteProfile?.contactPhone,
          required: true,
          placeholder: "Enter mobile no...",
          disabled: false,
          onChange: (e) => handleInputChange(e, "contactPhone"),
                  error: getContactPhoneError(instituteProfile?.contactPhone),
        },
        // {
        //   label: "Designation",
        //   type: "select",
        //   value: instituteProfile?.contactDesignation,
        //   required: true,
        //   disabled: false,
        //   onChange: (e) => handleInputChange(e, "contactDesignation"),
        //   options: designations,
        //   placeholder: "Select Designation...",
        // },
      ],
    },
    {
      heading: "Billing details",
      subHeading:
        "The information entered here will be included in future invoices.",
      fields: [
        {
          label: "Building No./Locality/Area",
          type: "text",
          value: instituteProfile?.localityBilling,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "localityBilling"),
          placeholder: "Enter Building No./Locality/Area...",
        },
        {
          label: "Pincode",
          type: "number",
          value: instituteProfile?.pincodeBilling,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "pincodeBilling"),
          placeholder: "Enter Pincode...",
          error: (() => {
            const pin = instituteProfile?.pincodeBilling;
            if (pin && pin.length >= 1 && pin.length < 6) {
              return "Enter valid pincode";
            }
            return instituteProfile?.pincodeBillingValid ? "Enter valid pincode" : "";
          })()
        },
        {
          label: "State",
          type: "text",
          value: instituteProfile?.stateBilling,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "stateBilling"),
          placeholder: "Enter State...",
        },
        {
          label: "District",
          type: "text",
          value: instituteProfile?.cityBilling,
          required: true,
          disabled: false,
          onChange: (e) => handleInputChange(e.target.value, "cityBilling"),
          placeholder: "Enter District...",
        },
        // {
        //   label: "Country",
        //   type: "text",
        //   value: instituteProfile?.countryBilling,
        //   required: true,
        //   disabled: true,
        //   onChange: (e) => handleInputChange(e.target.value, "countryBilling"),
        //   placeholder: "Enter Country...",
        // },
      ],
    },
  ];
};

const InstituteProfile = ({
  user,
  instituteDetails,
  saveInstituteDetails,
  deleteLogo,
}) => {
  const history = useHistory();
  useEffect(() => {
    setProfileDetails({ ...instituteDetails });
  }, [instituteDetails]);

  const instituteLogoRef = useRef(null);
  const [instituteProfile, setProfileDetails] = useState({});
  const [isSaveHidden, setIsSaveHidden] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [editLogoModal, setEditLogoModal] = useState(false);
  const [deleteConfirmation, setdeleteConfirmation] = useState(false);
  const [studentStrength, setStudentStrength] = useState("");

  const handleFocusChange = (val, key) => {
    const cleanVal = String(val || "").replace(/[^0-9]/g, "");
    if (key === "pincode" && cleanVal !== "" && cleanVal.length < 6) {
      instituteProfile.pincodeValid = true;
      setProfileDetails({ ...instituteProfile });
    } else if (key === "pincodeBilling" && cleanVal !== "" && cleanVal.length < 6) {
      instituteProfile.pincodeBillingValid = true;
      setProfileDetails({ ...instituteProfile });
    }
  };

  const handlePincodeChange = (pincode, section) => {
    if (!pincode) {
      if (section === "institute") {
        instituteProfile.state = "";
        instituteProfile.city = "";
        instituteProfile.country = "";
        instituteProfile.pincodeValid = undefined;
      } else if (section === "billing") {
        instituteProfile.stateBilling = "";
        instituteProfile.cityBilling = "";
        instituteProfile.pincodeBillingValid = undefined;
      }
      setProfileDetails({ ...instituteProfile });
      return;
    }

    getAddressFromPin(pincode, (district, state, country) => {
      const isValid = !!(district || state);
      if (section === "institute") {
        instituteProfile.pincodeValid = isValid ? undefined : true;
        instituteProfile.city = district;
        instituteProfile.state = state;
        instituteProfile.country = country;
      } else if (section === "billing") {
        instituteProfile.pincodeBillingValid = isValid ? undefined : true;
        instituteProfile.cityBilling = district;
        instituteProfile.stateBilling = state;
      }
      setProfileDetails({ ...instituteProfile });
    });
  };

  const handleInputChange = (val, key) => {
    if (key === "pincode") {
      const cleanVal = String(val || "").replace(/[^0-9]/g, "").slice(0, 6);
      instituteProfile[key] = cleanVal;
      
      if (cleanVal.length === 6) {
        handlePincodeChange(cleanVal, "institute");
      } else if (cleanVal.length < 6) {
        handlePincodeChange(null, "institute");
      }
    } else if (key === "pincodeBilling") {
      const cleanVal = String(val || "").replace(/[^0-9]/g, "").slice(0, 6);
      instituteProfile[key] = cleanVal;
      
      if (cleanVal.length === 6) {
        handlePincodeChange(cleanVal, "billing");
      } else if (cleanVal.length < 6) {
        handlePincodeChange(null, "billing");
      }
    } else if (key === "contactPhone") {
      if (typeof val === "string") {
        let phoneValue = val;
        if (phoneValue.startsWith("+91") && phoneValue.length > 13) {
          phoneValue = phoneValue.slice(0, 13);
        } else if (phoneValue.startsWith("91") && phoneValue.length > 12) {
          phoneValue = phoneValue.slice(0, 12);
        } 
        instituteProfile[key] = phoneValue;
      } else {
        instituteProfile[key] = val;
      }
    } else {
      instituteProfile[key] = val;
    }
    setProfileDetails({ ...instituteProfile });
    setStudentStrength({ ...instituteProfile });
  };
  console.log({ instituteProfile });

  useEffect(() => {
    setIsSaveHidden(
      JSON.stringify(instituteDetails) === JSON.stringify(instituteProfile)
    );
  }, [instituteProfile]);

  const handleLogoModalOk = () => {
    setEditLogoModal(false);
    instituteLogoRef?.current?.click();
  };
  const handleSaveClick = (callback, buttonCallback) => {
    const params = { ...instituteProfile };
    saveInstituteDetails(params, () => onSaveSuccess(callback), buttonCallback);
  };

  const onSaveSuccess = (callback) => {
    callback();
    setIsSaveHidden(true);
    history.push("/account-settings");
  };

  const onDeleteConfirm = (callback, successCallback) => {
    deleteLogo(callback, () => {
      successCallback();
      setdeleteConfirmation(false);
      setEditLogoModal(false);
      handleInputChange("defaultLogo.png", "logo");
      handleInputChange(undefined, "file");
      instituteLogoRef.current.value = null;
    });
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        title="Edit Institute"
        onBackPress={() => history.goBack()}
        actions={
          isSaveHidden
            ? null
            : [
                <Button
                  disabled={
                    // Institute details - required editable fields
                    !instituteProfile?.instituteType ||
                    !instituteProfile?.locality ||
                    !instituteProfile?.pincode ||
                    instituteProfile?.pincode?.length < 6 ||
                    !instituteProfile?.state ||
                    !instituteProfile?.city ||
                    !instituteProfile?.country ||
                    // Secondary contact details
                    !instituteProfile?.contactName ||
                    !instituteProfile?.contactEmail ||
                    !instituteProfile?.contactPhone ||
                    validateEmail(instituteProfile?.contactEmail) ||
                    !!getContactPhoneError(instituteProfile?.contactPhone) ||
                    // Billing details - required editable fields
                    !instituteProfile?.localityBilling ||
                    !instituteProfile?.pincodeBilling ||
                    instituteProfile?.pincodeBilling?.length < 6 ||
                    !instituteProfile?.stateBilling ||
                    !instituteProfile?.cityBilling
                  }
                  type="link"
                  style={{ fontSize: 14 }}
                  onClick={() => setShowConfirmModal(true)}
                >
                  SAVE
                </Button>,
              ]
        }
      />
      <ImageComponent
        src={instituteProfile?.logo}
        onChange={() => {}}
        handleEditModal={setEditLogoModal}
        ref={instituteLogoRef}
        setfileInputValue={(file) => {
          handleInputChange(file, "file");
        }}
        localImg={instituteProfile.file}
        imageRemove={!!instituteProfile.file}
      />
      <div style={{ padding: 20 }}>
        {instituteProfileDetails(instituteProfile, handleInputChange, user).map(
          (section, index) => (
            <DetailSection section={section} index={index} />
          )
        )}
      </div>
      <SaveConfirmation
        saveConfirmationModal={showConfirmModal}
        handleOk={(callback, buttonCallback) =>
          handleSaveClick(callback, buttonCallback)
        }
        onCancel={() => setShowConfirmModal(false)}
      />
      <EditImage
        imageUrl={instituteProfile?.logo}
        localImg={instituteProfile?.file}
        onEditCancel={() => setEditLogoModal(false)}
        editModalVisible={editLogoModal}
        setEditProfileModal={setEditLogoModal}
        handleEditOk={handleLogoModalOk}
        deleteConfirm={() => {
          setdeleteConfirmation(true), setEditLogoModal(false);
        }}
        deleteModalVisible={deleteConfirmation}
        setdeleteConfirmation={setdeleteConfirmation}
        onDeleteCancel={() => setdeleteConfirmation(false)}
        onDeleteConfirm={(callback, successCallback) =>
          onDeleteConfirm(callback, successCallback)
        }
        type="institute"
      />
      {/* <Prompt
        when={!isSaveHidden}
        message="You have unsaved changes, are you sure you want to leave?"
      /> */}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.session;
  const { instituteDetails } = state.profileNew;
  return {
    user,
    instituteDetails,
  };
};

const mapDispatchToProps = (dispatch) => ({
  deleteLogo: (callback, successCallback) =>
    dispatch(deleteLogo(callback, successCallback)),
  saveInstituteDetails: (params, callback, buttonCallback) =>
    dispatch(saveInstituteDetails(params, callback, buttonCallback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InstituteProfile);
